<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item">
            <router-link to="/admin/series/">
                Series
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Edit
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Edit Series

            <router-link
                :to="`/admin/series/${$route.params.id}/`"
                class="btn btn-primary btn-sm float-end"
            >
                View Lessons
            </router-link>
        </div>

        <div
            v-if="series.id"
            class="card-body"
        >
            <series-edit-form
                :endpoint="`/admin/api/series/${$route.params.id}`"
                method="put"
            >
            </series-edit-form>

            <hr class="my-5" />

            <series-translations-form
                endpoint="/admin/api/series-translations"
                :series-id="series.id"
                method="post"
            >
            </series-translations-form>

            <hr class="my-5" />

            <series-media-form
                :endpoint="`admin/api/series/${series.id}/attach`"
                :series-id="series.id"
                method="post"
            >
            </series-media-form>

        </div>

    </div>
</template>

<script>
import SeriesEditForm from "../../../admin/SeriesEditForm.vue";
import SeriesTranslationsForm from "../../../admin/SeriesTranslationsForm.vue";
import SeriesMediaForm from "../../../admin/SeriesMediaForm.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
    name: "SeriesEdit",

    components: {
        AdminBreadcrumbs,
        SeriesMediaForm,
        SeriesTranslationsForm,
        SeriesEditForm,
    },

    data() {
        return {
            series: {},
        };
    },

    mounted() {
        axios({
            method: "get",
            url: `/admin/api/series/${this.$route.params.id}`,
        })
            .then((response) => {
                this.series = response.data;
            });
    },
};
</script>
